<template>
  <div class="flex flex-col gap-2" :class="attrs.class">
    <OLabel v-if="attrs.label" :text="attrs.label" />
    <q-select
      ref="componentRef"
      class="Oselect label-transparent"
      :class="'size-' + attrs.size"
      popup-content-class="select-menu"
      input-debounce="300"
      transition-duration="150"
      options-selected-class="option-selecionada"
      :size="null"
      :options="options"
      dropdown-icon="expand_more"
      v-bind="attrs"
      :label="null"
      @filter="filterFn"
    >
      <!-- @focus="handleFocus" -->
      <template
        v-for="slot in Object.keys(slots)"
        #[slot]="slotProps"
      >
        <slot :name="slot" v-bind="slotProps || {}" />
      </template>

      <template #no-option>
        <q-item>
          <div class="flex items-center gap-8">
            <q-icon
              class="block mx-auto opacity-30"
              name="fluorescent"
              size="2rem"
            />
            <p class="opacity-40">Sem Dados para exibir.</p>
          </div>
        </q-item>
      </template>

      <!-- <template #before-options>
      <OInput
        ref="input"
        v-model="val"
        size="md"
        class="no-border !border-0"
        @keyup="handleInputChange"
      />
    </template> -->
    </q-select>
  </div>
</template>

<script>
export default { inheritAttrs: false }
</script>

<script setup>
import { nextTick, ref, useAttrs, useSlots, watch } from 'vue'
import OLabel from 'components/Label/OLabel.vue'

/** @typedef {import('quasar').QSelect} QSelect
 * @typedef {import('quasar').QSelectSlots} QSelectSlots
 */

/** @type {QSelect} */
const props = defineProps({})

/** @type {QSelectSlots} */
const _slots = defineSlots()

const val = ref('')
const slots = useSlots()
const attrs = useAttrs()
const componentRef = ref(null)

const options = ref(attrs.options)

let stringOptions = attrs.options

// function handleFocus() {
//   componentRef.value.showPopup()
// }
// asas
watch(
  () => attrs.options,
  async (v) => {
    await nextTick()
    options.value = attrs.options
    stringOptions = attrs.options
  },
  { deep: true }
)

function filterFn(val, update, abort) {
  update(() => {
    if (!val) return (options.value = stringOptions)
    const needle = String(val)?.toLowerCase()
    options.value = stringOptions.filter((v) => {
      const option = attrs['option-label']
        ? v[attrs['option-label']]
        : v
      const have = String(option)?.toLowerCase().indexOf(needle) > -1
      return have
    })
  })
}

defineExpose({ componentRef })
</script>

<style lang="sass" scoped></style>

<style lang="sass">
.q-select--multiple
  .q-field__native
    gap: 2px
    padding: 4px 2px 2px

.q-select--single
  .q-field__native
    flex-wrap: nowrap
    span
      flex: 0 3 auto
    input
      flex: 1
</style>
